export default __webpack_public_path__ + "static/media/maze-2.8f16c439.svg";